






































/* eslint-disable @typescript-eslint/camelcase */
import { inject } from 'inversify-props'
import API from '@core/services/API'
import { Component, Vue } from 'vue-property-decorator'
import AppDatatable from '@core/components/AppDatatable.vue'
import AppDialog from '@core/components/AppDialog.vue'
import AppForm from '@core/components/AppForm.vue'
import { IDateService } from '@core/services/IDateService'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'
import { omit } from 'lodash/fp'
import { FormStructure } from '@master/model/structure/FormStructure'
import { AccountTypeOptions, ClientProfile, StatusOptions, TitleOptions } from '@core/pages/client-management/model/ClientProfile'
import { ClientDto, ClientService } from './client-management/api'

interface Client {
  _oid: string;
  name: string;
  nric: string;
  mobile_number: string;
  status: string;
  client_since: string;
  account_type: string;
  redirect: string;
  keyword: string;
  is_deleted: boolean;
  client_id: string;
}

@Component({
  components: {
    AppDialog,
    AppDatatable,
    AppForm
  }
})

export default class ClientList extends Vue {
  private clientColumns: Array<object> = [
    { label: 'Client ID', field: 'client_id' },
    { label: 'Client Name', field: 'name' },
    { label: 'Status', field: 'status' },
    { label: 'Client Since', field: 'client_since' },
    { label: 'Account Type', field: 'account_type' }
  ]

  private clientRows: Client[] = []
  private clientKeys = ['_oid', 'nric', 'client_id', 'name', 'status', 'client_since', 'account_type', 'is_deleted']
  private clientProfile: ClientProfile = new ClientProfile()
  private isModalVisible = false
  private txtSearchTop = ''
  private recordsTotal = 0
  private currentDatatablePage = 1
  private pageSize = 10
  private searchTimeout = null

  @inject()
  private dateService: IDateService

  @inject()
  private $api: API

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  get structure (): FormStructure<ClientProfile> {
    return [
      {
        label: 'Account Type *',
        key: 'accountType',
        options: AccountTypeOptions
      },
      {
        label: 'Title',
        key: 'title',
        options: TitleOptions,
        show: this.clientProfile.accountType === 'individual'
      },
      {
        label: 'Name *',
        key: 'name'
      },
      {
        label: 'NRIC / Corporate No. *',
        key: 'nric'
      },
      {
        label: 'Mobile No.',
        key: 'mobileNumber'
      },
      {
        label: 'Status *',
        key: 'status',
        options: StatusOptions
      },
      {
        label: 'Client Since',
        key: 'clientSince',
        type: 'date'
      }
    ]
  }

  async created () {
    // take injected UIService and set it to local
    this.uiService = this.sharedVariable.uiService
    await this.getClient()
  }

  renameObjectKeys (list: Array<object>, keys: Array<string>): Array<object> {
    const newList = list.map(function (data) {
      const keyValues = Object.keys(data).map(function (key) {
        const newKey = keys[key]
        return { [newKey]: data[key] }
      })
      return Object.assign({}, ...keyValues)
    })
    return newList
  }

  async getClient () {
    const response = await this.$api.clientDetails.list({
      headers: JSON.stringify(this.clientKeys),
      orderBy: 'client_id'
      // query: { is_deleted: 1 }
      // queryArgs: JSON.stringify([isEmpty])
    })
    const allClientList = this.renameObjectKeys(response.data, this.clientKeys) as Client[]
    this.clientRows = allClientList.filter(client => !client.is_deleted).map(client => {
      if (client.client_since !== null) {
        client.client_since = this.dateService.format(client.client_since, 'YYYY-MM-DD')
      }
      client.redirect = '/live/client-info/' + client._oid
      client.keyword = Object.values(omit('redirect', client)).join(',').toLowerCase() // assign keyword with all object values except 'redirect' keys
      return client
    })
  }

  // searchDatatable () {
  //   clearTimeout(this.searchTimeout)

  //   // eslint-disable-next-line @typescript-eslint/no-this-alias
  //   const that = this
  //   this.searchTimeout = setTimeout(function () {
  //     that.currentDatatablePage = 1
  //     that.getClient()
  //   }, 1000)
  // }

  // onPageChange (currentPage: number) {
  //   this.currentDatatablePage = currentPage
  //   this.getClient()
  // }

  // onPageSizeChange (pageSize: number) {
  //   this.pageSize = pageSize
  //   this.getClient()
  // }

  showModal (): void {
    this.isModalVisible = true
    this.clientProfile = new ClientProfile()
  }

  closeModal (): void {
    this.isModalVisible = false
  }

  validate () {
    let valid = true
    const keys = ['name', 'nric', 'status', 'accountType']
    Object.keys(this.clientProfile).forEach(key => {
      const value = this.clientProfile[key]
      if (!keys.includes(key)) return
      if ((!value || value === '') && key !== 'oid') {
        valid = false
      }
    })
    return valid
  }

  async saveClient () {
    const valid = this.validate()
    if (!valid) {
      await this.uiService.alert.show({
        type: 'warning',
        message: 'Please complete all fields.'
      })
      return
    }

    const data = {
      title: this.clientProfile.title,
      name: this.clientProfile.name,
      nric: this.clientProfile.nric,
      mobileNumber: this.clientProfile.mobileNumber,
      status: this.clientProfile.status,
      clientSince: new Date(this.clientProfile.clientSince).getTime(),
      accountType: this.clientProfile.accountType
    }

    const response = await ClientService.createNewClient(data as ClientDto)
    window.location.href = '/live/client-info/' + response[0]?.oid
  }
}
